export default __webpack_public_path__ + "static/media/info.156396c4.svg";